<template>
  <div>
    <section
      class="add_new_head white--body tx--bege relative cover m_bg_blue"
      style="background-image: url('assets/img/layout/bg_head.jpg')"
    >
      <div class="popup_close close-animate">
        <a @click="goBackRoute"><CloseSvg /></a>
      </div>

      <a class="no_mobile link_goback" @click.prevent="goBackRoute"
        >חזרה <ArrowBack
      /></a>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <span class="bold">יצירת תור - </span>{{ activeDoctor.name }}
        </h1>
        <div class="add_step_all flex flex--content--center">
          <div class="add_step active">1</div>
          <div class="add_step">2</div>
          <div class="add_step">3</div>
          <div class="add_step">4</div>
        </div>
      </div>
    </section>
    <section class="add_new_main">
      <div class="add_st1" style="display: block">
        <div class="subtitle center">
          יש לבחור את סוג התור ולהקליד מספר ת.ז
        </div>
        <validation-observer
          v-if="filteredBlocks && filteredBlocks.length"
          ref="createAppForm"
        >
          <form
            @submit.prevent="sendForm"
            v-promise-btn="{ action: 'submit' }"
            autocomplete="off"
          >
            <div class="w-570">
              <div class="filter_select" :class="{ disabled: isBlockingApp }">
                <input
                  v-if="filteredBlocks && filteredBlocks.length === 1"
                  v-model="appointment_type"
                  disabled
                />
                <validation-provider
                  v-else
                  rules="required"
                  name="insurance"
                  v-slot="{ errors }"
                >
                  <select2
                    name="insurance"
                    v-model="appointment_type"
                    :disabled="isBlockingApp"
                  >
                    <option value="">בחרו סוג תור</option>
                    <option
                      v-for="block in filteredBlocks"
                      :key="block"
                      :value="block"
                    >
                      {{ block }}
                    </option>
                  </select2>
                  <div class="note">בחרו שילוב של סוג התור וסוג ביטוח</div>
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                </validation-provider>
              </div>
              <div
                class="form_input input-38"
                :class="{ focused: passport, disabled: isBlockingApp }"
              >
                <label>ת.ז*</label
                ><validation-provider
                  :rules="{ required: true, israeliId: [isDarcon] }"
                  name="passport"
                  v-slot="{ errors }"
                >
                  <input
                    name="passport"
                    v-mask="isDarcon ? 'X'.repeat(100) : ['####', '#########']"
                    v-model="passport"
                    type="tel"
                    :disabled="isBlockingApp"
                  />
                  <span class="error-message" v-if="errors.length > 0">{{
                    errors[0]
                  }}</span>
                  <div
                    class="error-message"
                    v-if="serverError"
                    v-html="serverError"
                  ></div>
                </validation-provider>
              </div>

              <div
                class="add_new_row flex desk-flex"
                :class="{ disabled: isBlockingApp }"
              >
                <div class="form_check form_check-black">
                  <label>
                    <input
                      type="checkbox"
                      v-model="isDarcon"
                      :disabled="isBlockingApp"
                    />
                    דרכון
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>

              <div
                class="add_new_row flex desk-flex"
                style="padding-top: 20px;"
              >
                <div class="form_check form_check-black">
                  <label>
                    <input type="checkbox" v-model="isBlockingApp" />
                    תור חוסם
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>

              <div
                v-if="!isBlockingApp && anesthesiaAppointment"
                class="add_new_row flex desk-flex"
                style="padding-top: 20px;"
              >
                <div class="form_check form_check-black">
                  <label>
                    <input type="checkbox" v-model="isAnesthesia" />
                    נדרש מרדים בית חולים
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>

              <div class="form_submit center" :class="{ bt_disable: notValid }">
                <button type="submit" class="bt_blue">הבא</button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
  </div>
</template>

<script>
import CloseSvg from "../../../assets/img/svg/close.svg";
import ArrowBack from "../../../assets/img/svg/arrow_r.svg";
import { mapGetters, mapActions } from "vuex";
import Error from "@/components/Popups/Error";
import { getHash } from "../../../utilities/hash.js";

export default {
  name: "AddNew",
  data() {
    return {
      isBlockingApp: false,
      isDarcon: false,
      isAnesthesia: false,
      doctorName: "",
      passport: "",
      block_id: "",
      start_date: "",
      end_date: "",
      insurance: "",
      appointment_type: "",
      serverError: "",
      blocks: [],
      filteredBlocks: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (typeof this.$route.query.passoport != "undefined") {
        this.passport = this.$route.query.passoport;
      }
      if (
        typeof this.$route.query.start != "undefined" &&
        typeof this.$route.query.end != "undefined" &&
        typeof this.$route.query.block_id != "undefined"
      ) {
        this.start_date = this.$route.query.start;
        this.end_date = this.$route.query.end;
        this.block_id = this.$route.query.block_id;
      }

      this.getSlots();
    });
  },
  watch: {
    activeDoctor: function(doc) {
      if (doc) {
        this.$nextTick(() => {
          this.getSlots();
        });
      }
    },
    isDarcon() {
      this.passport = "";
    }
  },
  computed: {
    ...mapGetters(["activeDoctor", "doctors"]),
    notValid() {
      if (!this.isBlockingApp && (!this.passport || !this.appointment_type)) {
        return true;
      }
      return false;
    },
    anesthesiaAppointment() {
      if (!this.appointment_type) return false;
      return (
        this.appointment_type.includes("קולונוסקופיה") ||
        this.appointment_type.includes("גסטרוסקופיה") ||
        this.appointment_type.includes("EUS")
      );
    }
  },
  methods: {
    ...mapActions(["SET_PATIENT", "SET_BLOCK", "SET_APPOINTMENT_TYPE"]),
    sendForm() {
      if (this.isBlockingApp) {
        // blocking app
        this.SET_PATIENT({
          apotropos: "",
          birth_date: "",
          first_name: "חסום",
          gender: "",
          id_num: "",
          last_name: "חסום",
          phone: "",
          second_phone: "",
          status: "",
          isBlockingApp: true
        });
        this.SET_APPOINTMENT_TYPE({
          appointment_type: "אחר",
          insurance: "אחר",
          blockFound: ""
        });
        let block = [];
        for (const index in this.blocks) {
          if (
            this.blocks[index].appointment_type &&
            this.blocks[index].insurance
          ) {
            block.push(this.blocks[index]);
          }
        }
        this.SET_BLOCK(block);
        if (this.start_date && this.end_date && this.block_id) {
          this.$router.push(
            "/app-add-info?start=" +
              this.start_date +
              "&end=" +
              this.end_date +
              "&block_id=" +
              this.block_id ?? ""
          );
        } else {
          this.$router.push("/app-add-info");
        }
      } else {
        // app

        let block = [];
        // appointment_type & insurance split by - from selected this.appointment_type
        let appointment_type;
        let insurance;
        const appNameSplitted = this.appointment_type.split("-");
        if (appNameSplitted.length > 2) {
          const find = this.blocks.find(block => {
            const fullType = block.appointment_type + "-" + block.insurance;
            if (this.appointment_type == fullType) return true;
            return false;
          });
          if (find) {
            appointment_type = find.appointment_type;
            insurance = find.insurance;
          } else {
            appointment_type = `${appNameSplitted[0]}-${appNameSplitted[1]}`;
            insurance = appNameSplitted[2];
          }
        } else {
          appointment_type = appNameSplitted[0];
          insurance = appNameSplitted[1];
        }
        //
        let blockFound = {};
        for (const index in this.blocks) {
          if (
            this.blocks[index].appointment_type &&
            this.blocks[index].insurance
          ) {
            block.push(this.blocks[index]);
          }
          if (
            this.blocks[index].appointment_type == appointment_type &&
            this.blocks[index].insurance == insurance
          ) {
            blockFound.cost_patient = this.blocks[index].cost_patient;
            blockFound.payment_method = this.blocks[
              index
            ].payment_method.payment_method;
          }
        }

        this.SET_APPOINTMENT_TYPE({
          appointment_type,
          insurance,
          blockFound,
          passport_type: this.isDarcon ? "foreign" : "israeli",
          anesthesia: this.isAnesthesia ? "מרדים פנימי" : ""
        });
        this.SET_BLOCK(block);

        return new Promise((resolve, reject) => {
          this.serverError = "";
          this.$refs.createAppForm
            .validate()
            .then(res => {
              if (res) {
                this.$API
                  .validatePassport(this.passport, this.appointment_type)
                  .then(res => {
                    if (res.status == "ERROR") {
                      this.SET_PATIENT({
                        apotropos: "",
                        birth_date: "",
                        first_name: "",
                        gender: "",
                        id_num: this.passport,
                        last_name: "",
                        phone: "",
                        second_phone: null,
                        status: ""
                      });
                    } else {
                      this.SET_PATIENT(res);
                    }

                    resolve();
                    if (this.block_id != "") {
                      this.$router.push(
                        "/app-add-info?start=" +
                          this.start_date +
                          "&end=" +
                          this.end_date +
                          "&block_id=" +
                          this.block_id
                      );
                    } else {
                      this.$router.push({ name: "app-add-info" });
                    }
                  })
                  .catch(e => {
                    this.SET_PATIENT({
                      apotropos: "",
                      birth_date: "",
                      first_name: "",
                      gender: "",
                      id_num: this.passport,
                      last_name: "",
                      phone: "",
                      second_phone: null,
                      status: ""
                    });

                    if (this.block_id != "") {
                      this.$router.push(
                        "/app-add-info?start=" +
                          this.start_date +
                          "&end=" +
                          this.end_date +
                          "&block_id=" +
                          this.block_id
                      );
                    } else {
                      this.$router.push({ name: "app-add-info" });
                    }
                  });
              } else {
                resolve();
              }
            })
            .catch(e => {
              this.$modal.show(Error);
              reject();
            });
        });
      }
    },
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || !Object.keys(hashData).length) {
        return this.$router.push("/dashboard");
      }
      const hash = getHash({});
      return this.$router.push("/dashboard/#" + hash);
    },
    getSlots(duration = "0.5") {
      if (parseFloat(duration) > 1) return;

      let startdate = this.$moment().format("YYYY-MM-DD");
      let endtdate = this.$moment(startdate, "YYYY-MM-DD")
        .add(duration, "y")
        .format("YYYY-MM-DD");

      this.$API
        .getScheduleTable(this.activeDoctor.id, startdate, endtdate)
        .then(res => {
          if (res && res.data && res.data.length) {
            this.blocks = res.data;
            this.blocks.forEach(block => {
              let key = block.appointment_type + "-" + block.insurance;
              if (
                !this.filteredBlocks.includes(key) &&
                block.appointment_type &&
                block.insurance
              ) {
                this.filteredBlocks.push(key);
              }
            });
            if (this.filteredBlocks && this.filteredBlocks.length === 1) {
              this.appointment_type = this.filteredBlocks[0];
            }
          } else {
            const newDuration = (parseFloat(duration) + 0.5).toString();
            this.getSlots(newDuration);
          }
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    }
  },
  components: {
    CloseSvg,
    ArrowBack
  }
};
</script>

<style scoped></style>
